import { Input } from "components";
import { formatAlphaOnly, formatCurrency, formatNumberOnly, formatPhoneNumber } from "@compass/core";
import { ApplicationQuestion, FormQuestion } from "generated/openApi";
import { FormQuestionWriteInTypes } from "pages/cobro/surveys/SurveyPage/Questions/SurveyQuestionEnum";
import { TransientQuestionResponse } from "./TransientQuestionResponse";
import CurrencyInput from "react-currency-input-field";
import { PhoneNumberInput } from "components/common/PhoneNumberInput";

export type OpenEndedQuestionProps = {
  question: ApplicationQuestion | FormQuestion;
  transientResponse: TransientQuestionResponse;
  updateQuestionResponse: (value: TransientQuestionResponse) => void;
  isDisabled?: boolean;
};

export const OpenEndedQuestion = ({
  question,
  transientResponse,
  updateQuestionResponse,
  isDisabled,
}: OpenEndedQuestionProps) => {
  const isFormQuestionCheck = (question: any): question is FormQuestion => {
    return (question as FormQuestion).formId !== undefined;
  };
  const isFormQuestion = isFormQuestionCheck(question);

  const currencyStyle = {
    color: "rgba(0, 0, 0, 0.87)",
    padding: "16.5px 14px",
    minWidth: `${isFormQuestion ? question.writeInWidthPercent || "100" : "100"}%`,
    borderRadius: "5px",
    borderWidth: "1.25px",
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.20)" 
  };

  return (
    <>
      {(question.formQuestionWriteInTypeId != FormQuestionWriteInTypes.Currency && question.formQuestionWriteInTypeId != FormQuestionWriteInTypes.PhoneNumber) && (
        <Input
          sx={{ maxWidth: `${isFormQuestion ? question.writeInWidthPercent || "100" : "100"}%` }}
          value={
            question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Date
              ? transientResponse.writeInDate
              // : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber
              // ? formatPhoneNumber(transientResponse.writeIn)
              : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Number
              ? formatNumberOnly(transientResponse.writeIn)
              : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.AlphaOnly 
              ? formatAlphaOnly(transientResponse.writeIn)
              : transientResponse.writeIn
          }
          required={question.isMandatory}
          disabled={isDisabled}
          multiline={question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Textarea}
          type={
              question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Number
              ? "number"
              : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Date && !isDisabled
              ? "date"
              : "text"
          }
          maxLength={question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber ? 15 : undefined}
          onChange={(e) => {
            updateQuestionResponse({
              ...transientResponse,
              writeInDate: question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Date ? e.target.value : null,
              writeIn: question.formQuestionWriteInTypeId != FormQuestionWriteInTypes.Date ? 
              question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Number ? formatNumberOnly(e.target.value) || null
              // question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber ? formatPhoneNumber(e.target.value) || null
              : e.target.value 
              : null,
            });
          }}
          onKeyDown={(e) => {
            // Block e, E, +, - on number input
            if (
              question.formQuestionWriteInTypeId === FormQuestionWriteInTypes.Number &&
              ["e", "E", "+", "-"].includes(e.key)
            ) {
              e.preventDefault();
            }
          }}
        />
      )}
      {question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Currency && (
        <CurrencyInput
          style={currencyStyle}
          id={question.id.toString()}
          disabled={isDisabled}
          prefix="$"
          defaultValue={question.defaultAnswer || undefined}
          value={transientResponse.writeIn || undefined}
          decimalsLimit={2}
          onValueChange={(value, name, values) => {
            updateQuestionResponse({
              ...transientResponse,
              writeIn: value || null
            });
          }}
        />
      )}
      {question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber && (
        <PhoneNumberInput
          isDisabled={isDisabled}
          required={question.isMandatory}
          value={transientResponse.writeIn || undefined}
          updatePhoneNumber={(value) => {
            updateQuestionResponse({
              ...transientResponse,
              writeIn: value || null
            });
          }}
        />
      )}
    </>
  );
};
